module.exports = __webpack_public_path__ + "static/tulsa-3-4-4bef63b292b701f79fb795cc8105f088.jpg";